import { render } from "./LoyaltyProductsPage.vue?vue&type=template&id=1e3cac15&scoped=true&ts=true"
import script from "./LoyaltyProductsPage.vue?vue&type=script&lang=ts"
export * from "./LoyaltyProductsPage.vue?vue&type=script&lang=ts"

import "./LoyaltyProductsPage.vue?vue&type=style&index=0&id=1e3cac15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3cac15"]])

export default __exports__